import {
  CSP_LABEL_KEY,
  STORE_KEYS,
} from 'src/services/ProfessionApiStore.const'
import type { Scalar } from 'src/tpbp-core/models/global.type'
import { byKey } from 'src/tpbp-core/utils/common.utils'
import type { CspModel } from 'src/tpbp-json-api-handler/models/models'
import { getStoredData } from 'src/tpbp-json-api-handler/utils/ApiStore'

function getCsps(): CspModel[] {
  return getStoredData(STORE_KEYS.csps)
}

export const getCspCodes = (): Scalar[] =>
  getStoredData(STORE_KEYS.cspCodes, () => {
    const csps = getCsps()

    return csps.map(({ csp }) => csp) ?? []
  })

export const getCspCategoryCodes = (): string[] =>
  getStoredData(STORE_KEYS.cspCategoryCodes, () => {
    const csps = getCsps()

    return csps.reduce<number[]>((categoryCodes, { category }) => {
      if (!categoryCodes.includes(category)) {
        categoryCodes.push(category)
      }

      return categoryCodes
    }, [])
  })

export const groupCspByCategory = (csps: CspModel[]): Map<number, string[]> =>
  csps.reduce((cspCodesByCategory, { category, csp }) => {
    if (cspCodesByCategory.has(category)) {
      const csps = cspCodesByCategory.get(category)
      csps?.push(csp)
    } else {
      cspCodesByCategory.set(category, [csp])
    }

    return cspCodesByCategory
  }, new Map<number, string[]>())

export function getCspCodesByCategory() {
  return getStoredData(STORE_KEYS.cspCodesByCategory, () => {
    const csps = getCsps()
    const cspCodesByCategory = groupCspByCategory(csps)

    return cspCodesByCategory
  })
}

export const getCspLabels = () =>
  getStoredData(STORE_KEYS.cspLabels, () => {
    const csps = getCsps()
    const list = byKey(csps, 'csp', (row) => row[CSP_LABEL_KEY])

    return list
  })

export const getCspCategoryLabels = () =>
  getStoredData(STORE_KEYS.cspCategoriesLabels, () => {
    const csps = getCsps()
    const list = byKey(csps, 'category', (row) => row.categoryLabel)

    return list
  })
